var map = {
	"./images/academy-logo-black.svg": "b0cf",
	"./images/alert-icon-color.svg": "ae49",
	"./images/arrow-left-icon-dark-grey.svg": "6e13",
	"./images/arrow-right-icon-dark-grey.svg": "70da",
	"./images/check-icon-color.svg": "7f87",
	"./images/check-icon-green.svg": "e8f4",
	"./images/check-icon-grey.svg": "8c82",
	"./images/check-icon-white.svg": "f217",
	"./images/compliance-logo-black.svg": "5850",
	"./images/computer-icon-white.svg": "6f8e",
	"./images/dfs-logo-black.svg": "fba9",
	"./images/email-icon.svg": "7239",
	"./images/grid-icon.svg": "5416",
	"./images/group-logo-black.svg": "80b2",
	"./images/group-logo-symbol.svg": "e370",
	"./images/group-logo-white.svg": "6d9f",
	"./images/group-logotype-white.svg": "7d67",
	"./images/logout-icon-color.svg": "9ba7",
	"./images/settings-icon.svg": "0ab9",
	"./images/support-icon.svg": "6b9a",
	"./images/user-check-icon.svg": "2ea5",
	"./images/x-icon-grey.svg": "71e7",
	"./images/x-icon-red.svg": "34db",
	"./images/x-icon-white.svg": "85ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";